import { render } from "./SearchProducts.vue?vue&type=template&id=25a64ac0&scoped=true"
import script from "./SearchProducts.vue?vue&type=script&lang=js"
export * from "./SearchProducts.vue?vue&type=script&lang=js"

import "./SearchProducts.vue?vue&type=style&index=0&id=25a64ac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a64ac0"]])

export default __exports__